<template>
    <section>
        <!-- FORGOT PASSWORD FORM -->
        <div class="forgotPassFormWrapper">
            <v-form
                ref="form"
                v-model="valid"
                class="forgotPassForm d-flex justify-space-around align-center"
                @submit.prevent="validate()"
            >
                <v-card class="elevation-5 forgotPassCard" shaped>
                    <v-container>
                        <div class="forgotPass">
                            <img src="../../../assets/newpassword.svg" alt="">
                        </div>
                        <v-alert
                            v-model="error.status"
                            dismissible
                            class="text-center"
                            transition="scale-transition"
                            style="position: absolute; z-index: 2; left: 0; right: 0; top: calc(20% - 10px); margin: 0 10px; border-radius: 16px;"
                            type="success"
                        >
                            {{ error.message }}
                        </v-alert>
                        <v-card-title>Reset password </v-card-title>
                        <v-divider />
                        <v-card-text class="text-center">
                            <div class="txtfieldWrapper">
                                <v-text-field
                                    v-model="newPass"
                                    label="Enter your new password"
                                    color="green accent-4"
                                    :rules="passwordRule"
                                    :append-icon="showPass.new ? mdiEye : mdiEyeOff"
                                    :type="showPass.new ? 'text' : 'password'"
                                    @click:append="showPass.new = !showPass.new"
                                />
                                <v-text-field
                                    v-model="retypedPass"
                                    label="Retype your new password"
                                    color="green accent-4"
                                    :rules="retypePasswordRule.concat([(newPass === retypedPass) || 'Password does not match.'])"
                                    :append-icon="showPass.retype ? mdiEye : mdiEyeOff"
                                    :type="showPass.retype ? 'text' : 'password'"
                                    @click:append="showPass.retype = !showPass.retype"
                                />
                            </div>
                            <v-btn
                                type="submit"
                                small
                                :disabled="disable_btn"
                                color="green accent-4 white--text"
                                class="my-3"
                            >
                                <h4>Reset</h4>
                            </v-btn>
                        </v-card-text>
                    </v-container>
                </v-card>
            </v-form>
        </div>

    <!-- END FORGOT PASSWORD FORM -->
    </section>
</template>

<script>
import { mdiEye, mdiEyeOff } from '@mdi/js'
import { mapActions, mapGetters } from 'vuex'

export default {
    data: () => ({
        mdiEye, mdiEyeOff,
        showPass:{
            new: false,
            retype: false
        },
        error: {
            status: false,
            message: ''
        },
        membCodeRule: [(v) => !!v || 'Member Code is required'],
        passwordRule: [
            (v) => !!v || 'Enter your password',
            (v) =>
                // validate the new regex here https://regexr.com/7rr6e
                // /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(validation) ||
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d!@#$%^&*()-_=+{};:,.<>?/\\|\[\]~]{8,}$/.test(v) ||
                'Must contain uppercase, lowercase and number and at least 8 characters '
        ],
        retypePasswordRule: [
            (v) => !!v || 'Retype your password'
        ],
        valid: true,
        newPass: '',
        retypedPass: '',
        disable_btn: false
    }),
    computed: {
        ...mapGetters(['getForgotPassUserInfo', 'forgottenMembn', 'passwordChanged'])
    },
    watch: {
        passwordChanged(newVal) {
            // console.log('passwordChanged newVal: ', newVal)
            if (newVal) {
                this.error = {
                    status: true,
                    message: newVal
                }
            }
        }
    },
    async created() {
        this.verifyForgotPassRecoveryLink({ TOKEN: this.$route.query.reset_token })
    },
    methods: {
        ...mapActions(['verifyForgotPassRecoveryLink', 'resetPassword', 'getCsrfToken']),
        validate() {
            this.showPass.new = false
            this.showPass.retype = false
            if (this.$refs.form.validate()) {
                this.disable_btn = true
                this.resetPassword({
                    TOKEN: this.$route.query.reset_token,
                    MEMBN: this.forgottenMembn,
                    PASS: this.newPass,
                    RETYPED_PASS: this.retypedPass
                })
            }
        }
    }
}
</script>

<style scoped>
section {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 100%;
  background-image: url("../../../assets/loginBG.webp");
  background-position: center;
  background-size: cover;
}
.forgotPassFormWrapper {
  width: 100%;
}
.displayForgotAccnt {
  display: none;
  width: 100%;
}
.forgotPassCard {
  background-image: url("../../../assets/mail-bg-wrapper.webp");
  background-size: cover;
  background-position: right;
  width: 30%;
}
.forgotPass {
  width: 50%;
  margin: auto;
}
.forgotPass img {
  width: 100%;
}
.txtfieldWrapper {

}
@media (max-width: 599px) {
  .forgotPassCard {
    width: 90%;
  }
}
</style>
